import React, { useState } from "react";
import { handleFormikValueChange } from "../../utils";
import InputGroup from "./InputGroup";
import Select from "./Select";
import { backendShape, withBackend } from "../../context";
import { withConfiguration } from "../../context/ConfigurationContext";

type Props = {
  backend?: backendShape;
  all?: boolean;
  disabled?: boolean;
  values?: $TSFixMe;
  name?: string;
  configuration: {
    language: string;
  };
};

export function CountriesSelectFormik(props: Props) {
  const { backend, all, disabled, values, name, configuration } = props;

  const [state, setState] = useState({
    fetching: false,
    countries: undefined,
    selectedCountry: undefined,
  });

  const loadCountries = async () => {
    try {
      setState({
        fetching: true,
        // @ts-expect-error TS(2322) FIXME: Type 'never[]' is not assignable to type 'undefine... Remove this comment to see the full error message
        countries: [],
        // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'undefined'.
        selectedCountry: null,
      });
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const response = await backend.get("/countries", {
        all,
        language: configuration.language,
      });
      setState({
        fetching: false,
        countries: response.countries,
        selectedCountry:
          // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
          values && values[name] ? values[name] : response.countries[0],
      });
    } catch {
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ fetching: false; }' is not ass... Remove this comment to see the full error message
      setState({ fetching: false });
    }
  };

  React.useEffect(() => {
    loadCountries();
  }, []);

  return (
    <InputGroup {...props}>
      <Select
        // @ts-expect-error TS(2322) FIXME: Type '{ id: string; name: string; valueKey: string... Remove this comment to see the full error message
        id="countries-select"
        name="countries"
        valueKey="code"
        options={state.countries}
        selectedOption={state.selectedCountry}
        onChange={(value) => handleFormikValueChange(props, value)}
        disabled={disabled || state.fetching}
      />
    </InputGroup>
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type 'ForwardRefExoticComponent<Omit<P... Remove this comment to see the full error message
export default withBackend(withConfiguration(CountriesSelectFormik));
